export default __webpack_public_path__ + "static/media/bannana republic.db38ff21.svg";